module.exports = __webpack_public_path__ + "img/suzuki-logo.e9297f51.svg";